var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"text--base chart__white"},[(_vm.packedCirclesTitle)?_c('PackedCirclesInvestment',{attrs:{"content":_vm.packedCirclesTitle}}):_vm._e()],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }